import React from 'react'

import { IconDesign, IconDevelopment, IconMarketing, IconSupport } from '.'

const IconTabs = ({ name }) => {
  switch (name) {
    case 'shopify-design':
      return <IconDesign />
    case 'shopify-development':
      return <IconDevelopment />
    case 'shopify-marketing':
      return <IconMarketing />
    case 'shopify-support':
      return <IconSupport />
    default:
      return <IconDesign />
  }
}

export default IconTabs
